import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { Mask, MaskUploadUrlData } from '../types';

export function useMaskDetails(maskId: string) {
  const { data: uploadUrlData, refetch: refetchUploadUrl } =
    useApiQuery<MaskUploadUrlData>(`/masks/reupload-url/${maskId}`, {
      queryKey: ['maskDetailsUploadUrl'],
      initialData: null,
    });

  const { isFetching, data } = useApiQuery<Mask>(`/masks/${maskId}`, {
    queryKey: ['maskDetails'],
    initialData: null,
  });

  const updateStyleMutation = useApiMutation<Mask>(
    '/masks',
    {
      method: 'PATCH',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    uploadUrlData,
    details: data,
    refetchUploadUrl,
    updateStyleMutation,
  } as const;
}
